"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
require("bootstrap/dist/css/bootstrap.min.css");
const UserIcon_1 = __importDefault(require("mdi-react/UserIcon"));
const moment_1 = __importDefault(require("moment/moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_ga_1 = __importDefault(require("react-ga"));
const FacebookPixelLocation_1 = require("../facebookPixelLocation/FacebookPixelLocation");
const constants_1 = require("../../assets/constants/constants");
const calendar_icon_white_svg_1 = __importDefault(require("../../assets/images/calendar-icon-white.svg"));
const logo_webp_1 = __importDefault(require("../../assets/images/logo.webp"));
const data_repository_1 = require("../../dataSource/data_repository");
const BookingExceptionHandle_1 = __importDefault(require("../../exceptions/BookingExceptionHandle"));
const suitesReserve_1 = require("../../redux/actions/suitesReserve");
const format_1 = require("../../utils/format");
const helpers_1 = require("../../utils/helpers");
const galleryImagesComponent_1 = __importDefault(require("../galleryImagesComponent/galleryImagesComponent"));
const RangePickerComponent_1 = __importDefault(require("../rangePickerComponent/RangePickerComponent"));
const Text_1 = __importDefault(require("../shared/Text"));
require("./BookComponent.scss");
const Amenities_1 = __importDefault(require("../../pages/accountInfo/reserves/components/amenities/Amenities"));
const SelectGuestComponent_1 = __importDefault(require("../formComponents/selectGuestComponent/SelectGuestComponent"));
const regex_1 = require("../../utils/regex");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const rangePickerBookingName = 'range-booking';
const guestsBookingName = 'guestsBooking';
const initialData = {
    selectedDate: [null, null],
};
const initialConfirmValues = {
    initialDate: (0, moment_1.default)(),
    finalDate: (0, moment_1.default)(),
    initialDay: '22',
    initialDayWeek: 'TER',
    initialmonth: 'NOV',
    finalDay: '25',
    finalDayWeek: 'SEX',
    finalmonth: 'DEZ',
    suiteQtyString: '01',
    dailyQtyString: '02',
    guestsQtyString: '02',
    suitePrice: '278,00',
    cleaningFee: constants_1.DEFAULT_CLEANING_FEE,
    totalNumber: '353',
    totalDecimal: '00',
    firstNight: '01-01-2000',
    lastNight: '01-02-2000',
    suite: {},
    quantity: 10,
    guestsQty: constants_1.DEFAULT_GUESTS_PER_ROOM,
    price: 100,
    priceValueFormatted: '100,00',
    discountPercent: 10,
    priceGross: 1000,
    priceGrossFormatted: '100,00',
    originalTotalPrice: 1000,
    totalPrice: 1000,
    bookId: '',
    isFromBookingInChart: false,
};
const MINIMUM_TO_SHOW_BANNER = 1;
const BookComponent = ({ queryURL, suite, propertiesLength, noAvailableSuites }) => {
    const [isModalSuiteVisible, setIsModalSuiteVisible] = (0, react_1.useState)(false);
    const [isModalConfirmVisible, setIsModalConfirmVisible] = (0, react_1.useState)(false);
    const [amenitiesMobileVisible, setAmenitiesMobileVisible] = (0, react_1.useState)(false);
    const [showContinueButton, setShowContinueButton] = (0, react_1.useState)(false);
    const [disableContinueButton, setDisableContinueButton] = (0, react_1.useState)(false);
    const [form] = antd_1.Form.useForm();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [confirmValues, setConfirmValues] = (0, react_1.useState)(initialConfirmValues);
    const [disableDate, setDisableDate] = (0, react_1.useState)(false);
    const [rangePickerInitialValues, setRangePickerInitialValues] = (0, react_1.useState)(null);
    const [guestsInitialValue, setGuestsInitialValue] = (0, react_1.useState)(constants_1.DEFAULT_GUESTS_PER_ROOM);
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    const [unavailableDates, setUnavailableDates] = (0, react_1.useState)([]);
    const [showRangeError, setShowRangeError] = (0, react_1.useState)(false);
    const [amenities, setAmenities] = (0, react_1.useState)({});
    const URLParams = (0, react_router_dom_1.useLocation)();
    const [isModalCheckAmenities, setIsModalCheckAmenities] = (0, react_1.useState)(false);
    const { state } = (0, react_router_dom_1.useLocation)();
    const hiddenModalSuite = (0, react_1.useCallback)(() => {
        setIsModalSuiteVisible(false);
        dispatch((0, suitesReserve_1.setActiveBuild)(null));
        document.title = `360 Suítes - Reservas`;
        let { search } = URLParams;
        search = search.replaceAll('?open=true', '');
        search = search.replaceAll('&open=true', '');
        search = search.replaceAll(regex_1.REGEX_URL_ROOMID, '');
        history.push(`${URLParams.pathname}${search}`);
        react_ga_1.default.pageview(window.location.pathname + window.location.search);
    }, [URLParams, dispatch, history]);
    const CreateTitlePage = (0, react_1.useCallback)((data) => {
        dispatch((0, suitesReserve_1.setActiveBuild)(suite.suiteTitle));
        document.title = `360 Suítes - ${data.suiteTitle}`;
    }, [dispatch, suite.suiteTitle]);
    const sendEventClickFacebookPixel = () => {
        let checkinDate = '';
        let checkoutDate = '';
        if (queryURL === null || queryURL === void 0 ? void 0 : queryURL.selectedDate) {
            const { selectedDate } = queryURL;
            [checkinDate, checkoutDate] = selectedDate;
        }
        (0, FacebookPixelLocation_1.sendFBPixel)('ViewCategory', {
            content_ids: `${suite.roomId}`,
            content_type: suite.propId,
            checkin_date: checkinDate,
            checkout_date: checkoutDate,
        });
    };
    const showModalSuite = (0, react_1.useCallback)(() => {
        setIsModalSuiteVisible(true);
        if (URLParams.search) {
            if (suite.roomId) {
                history.push(`${URLParams.pathname}${URLParams.search}&roomId=["${suite.roomId}"]&open=true`);
            }
            else {
                history.push(`${URLParams.pathname}${URLParams.search}&open=true`);
            }
        }
        else {
            history.push(`${URLParams.pathname}${URLParams.search}?open=true`);
        }
        sendEventClickFacebookPixel();
        CreateTitlePage(suite);
        react_ga_1.default.pageview(window.location.pathname + window.location.search);
    }, [CreateTitlePage, URLParams.pathname, URLParams.search, history, suite]);
    const showModalConfirm = (0, react_1.useCallback)(() => {
        setIsModalConfirmVisible(true);
    }, []);
    const loadModalRoomByDate = (0, react_1.useCallback)((initialDateString, finalDateString, guests) => __awaiter(void 0, void 0, void 0, function* () {
        if (!initialDateString || !finalDateString) {
            return;
        }
        const params = {
            roomId: suite.roomId,
            from: (0, moment_1.default)(initialDateString, 'DD/MM/YYYY').format('yyyy-MM-DD'),
            to: (0, moment_1.default)(finalDateString, 'DD/MM/YYYY').format('yyyy-MM-DD'),
            maxPeople: guests,
        };
        setDisableContinueButton(true);
        yield (0, data_repository_1.getAvailableRoomDetails)(params)
            .then(response => {
            if (!response.isError) {
                const initialDate = (0, moment_1.default)(initialDateString, 'DD/MM/YYYY');
                const finalDate = (0, moment_1.default)(finalDateString, 'DD/MM/YYYY');
                const dailyQtyString = (0, format_1.zeroPad)(finalDate.diff(initialDate, 'days'), 2);
                const guestsQtyString = (0, format_1.zeroPad)(guests, 2);
                const { cleaningFee } = suite;
                const cleaningFeeFormated = (0, format_1.getFormattedDouble)(cleaningFee);
                const { room } = response;
                const totalPrice = Number(room.totalPrice) + Number(suite.cleaningFee);
                const amount = (0, format_1.getFormattedDouble)(totalPrice).toString().split(',');
                const totalNumber = amount[0];
                const totalDecimal = (0, format_1.zeroPad)(amount[1], 2);
                const suitePrice = (0, format_1.getFormattedDouble)(room.totalPrice);
                const newConfirmValues = {
                    initialDate,
                    finalDate,
                    initialDay: initialDate.format('DD'),
                    initialDayWeek: initialDate.locale('pt-br').format('ddd'),
                    initialmonth: initialDate.locale('pt-br').format('MMM'),
                    finalDay: finalDate.format('DD'),
                    finalDayWeek: finalDate.locale('pt-br').format('ddd'),
                    finalmonth: finalDate.locale('pt-br').format('MMM'),
                    suiteQtyString: constants_1.DEFAULT_SUITE_QTDY,
                    dailyQtyString,
                    guestsQtyString,
                    suitePrice,
                    cleaningFee,
                    totalNumber,
                    totalDecimal,
                    firstNight: initialDate.format('yyyy-MM-DD'),
                    lastNight: finalDate.format('yyyy-MM-DD'),
                    suite,
                    quantity: room.quantity,
                    guestsQty: guests,
                    price: room.price,
                    priceValueFormatted: (0, format_1.getFormattedDouble)(room.price),
                    discountPercent: room.discountPercent,
                    priceGross: room.priceGross,
                    priceGrossFormatted: (0, format_1.getFormattedDouble)(room.priceGross),
                    originalTotalPrice: totalPrice,
                    totalPrice,
                    bookId: '',
                    cleaningFeeFormated,
                    isFromBookingInChart: false,
                };
                setConfirmValues(newConfirmValues);
            }
            else {
                antd_1.message.error('Ocorreu um erro ao carregar os dados. Tente novamente mais tarde.');
            }
            setDisableContinueButton(false);
            react_ga_1.default.event({
                category: 'Button',
                action: 'Click button "Continuar"',
            });
        })
            .catch(err => {
            console.error('Erro ', err);
            antd_1.message.error('Ocorreu um erro. Tente novamente mais tarde.');
            setDisableContinueButton(false);
        });
    }), [suite]);
    (0, react_1.useEffect)(() => {
        const formValues = {};
        if (queryURL && queryURL.selectedDate && queryURL.selectedDate.length) {
            const { selectedDate } = queryURL;
            setRangePickerInitialValues({
                before: selectedDate[0] ? selectedDate[0] : undefined,
                after: selectedDate[1] ? selectedDate[1] : undefined,
            });
            setDisableDate(true);
            setShowContinueButton(true);
            const initialDateString = form.getFieldValue(`initialDate-${rangePickerBookingName}`);
            const finalDateString = form.getFieldValue(`finalDate-${rangePickerBookingName}`);
            const guests = form.getFieldValue(`${guestsBookingName}Guests`);
            loadModalRoomByDate(initialDateString, finalDateString, guests);
        }
        else {
            setRangePickerInitialValues({
                before: undefined,
                after: undefined,
            });
            setDisableDate(false);
            setShowContinueButton(false);
        }
        if (queryURL && queryURL.guests && !noAvailableSuites) {
            const { guests } = queryURL;
            setGuestsInitialValue(guests);
        }
        else {
            setGuestsInitialValue(Math.min(constants_1.DEFAULT_GUESTS_PER_ROOM, suite.maxPeople));
        }
    }, [form, queryURL]);
    (0, react_1.useEffect)(() => {
        if (state && suite.roomId === state.roomId)
            showModalSuite();
    }, [state, suite.roomId, showModalSuite]);
    (0, react_1.useEffect)(() => {
        // Faz a pesquisa somente quando exibe o modal e quando a data ainda nõa foi selecionada
        if (isModalSuiteVisible && !disableDate) {
            setShowRangeError(false);
            setLoading(true);
            const params = {
                propId: suite.propId,
                roomId: suite.roomId,
            };
            (0, data_repository_1.getNotAvailableDates)(params)
                .then(response => {
                if (!response.isError) {
                    setUnavailableDates(response.rooms.map((room) => {
                        const date = room.dates.split('-');
                        return `${date[2]}/${date[1]}/${date[0]}`;
                    }));
                }
                else {
                    antd_1.message.error('Ocorreu um erro ao carregar as datas disponíveis.');
                }
                setLoading(false);
            })
                .catch(err => {
                console.error('Erro ', err);
                setLoading(false);
            });
        }
    }, [suite, isModalSuiteVisible, disableDate]);
    const handleSelectData = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        form.validateFields().then(values => {
            const initialDateString = values[`initialDate-${rangePickerBookingName}`];
            const finalDateString = values[`finalDate-${rangePickerBookingName}`];
            if (initialDateString && finalDateString) {
                setIsModalSuiteVisible(false);
                showModalConfirm();
            }
            else {
                setShowRangeError(true);
            }
        });
    }), [form, showModalConfirm]);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        (0, helpers_1.handleCleanBookingStorage)();
        // Quantidade de hóspedes preenchidos no formulário
        localStorage.setItem('XP360:filledGuestsNumber', (0, helpers_1.encrypty)('0'));
        const endPoint = '/bookings/request';
        const params = {
            roomId: confirmValues.suite.roomId,
            roomQty: confirmValues.suiteQtyString,
            status: constants_1.STATUS_REQUEST_BEDS24,
            firstNight: confirmValues.firstNight,
            lastNight: confirmValues.lastNight,
            numAdult: confirmValues.guestsQtyString,
            checkAvailability: true,
        };
        setLoading(true);
        (0, data_repository_1.post)({ url: endPoint, query: {}, params, clientOptions: {} })
            .then(response => {
            const data = response;
            if (!data.isError) {
                confirmValues.bookId = data.booking.bookingId;
                localStorage.setItem(constants_1.LOCAL_STORAGE.bookingId, (0, helpers_1.encrypty)(data.booking.bookingId));
                localStorage.setItem('XP360:beds_bookId', (0, helpers_1.encrypty)(String(data.booking.bookId)));
                localStorage.setItem(constants_1.LOCAL_STORAGE.confirmValues, (0, helpers_1.encrypty)(JSON.stringify(confirmValues)));
                localStorage.setItem('XP360:suite_features', (0, helpers_1.encrypty)(JSON.stringify(amenities)));
                localStorage.setItem('XP360:suite_roomId', (0, helpers_1.encrypty)(String(suite.roomId)));
                history.push(RoutesPaths_1.routesPaths.paymentBooking);
                (0, FacebookPixelLocation_1.sendFBPixel)('CheckoutTrack', 'InitiateCheckout');
            }
            else {
                (0, BookingExceptionHandle_1.default)(data);
            }
            setLoading(false);
        })
            .catch(err => {
            (0, BookingExceptionHandle_1.default)(err.response);
            setLoading(false);
        });
    }), [confirmValues, history]);
    const dateTimeStringSP = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    const dateStringSP = dateTimeStringSP.split(' ')[0].split('/');
    const initialDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    const finalDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    finalDate.setFullYear(finalDate.getFullYear() + 1);
    finalDate.setDate(finalDate.getDate() - 1);
    const handleSelectBuildingToShowInBanner = () => {
        dispatch((0, suitesReserve_1.setBuildingName)({ showThis: suite.propId }));
        window.scrollTo({ behavior: 'smooth', top: 0 });
    };
    (0, react_1.useEffect)(() => {
        let { search } = URLParams;
        if (search.includes('open')) {
            search = search.replace('?open=true', '');
            search = search.replace('&open=true', '');
            history.push(`${URLParams.pathname}${search}`, state);
        }
    }, []);
    return (react_1.default.createElement("div", { id: "BookComponent" },
        react_1.default.createElement("div", { className: "image-container", onClick: showModalSuite },
            react_1.default.createElement("img", { className: "image", src: suite.image, alt: "" }),
            disableDate ? (react_1.default.createElement("div", { className: "select-data reservation" }, "Reservar")) : (react_1.default.createElement("div", { className: "select-data" }, "Selecione a data"))),
        react_1.default.createElement("div", { className: "title" }, suite.suiteTitle),
        react_1.default.createElement("div", { className: "description" },
            `${suite.description}...`,
            react_1.default.createElement("div", { className: "divFormat" },
                react_1.default.createElement("div", { className: "divGradient" }),
                react_1.default.createElement("div", { className: "divButton" },
                    react_1.default.createElement(antd_1.Button, { className: "buttonFormat", onClick: showModalSuite }, "Ver mais")))),
        react_1.default.createElement("div", { className: "footer" },
            react_1.default.createElement("div", { className: `amenities ${propertiesLength > MINIMUM_TO_SHOW_BANNER && 'minFont'}`, onClick: handleSelectBuildingToShowInBanner },
                react_1.default.createElement("span", null, "Info. do edif\u00EDcio")),
            react_1.default.createElement("div", { className: "price" }, suite.discountPercent && suite.discountPercent > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "discount-percentage" }, `${suite.discountPercent}% off`),
                react_1.default.createElement("span", { className: "original-price" }, `R$ ${suite.priceGrossFormatted}`),
                react_1.default.createElement("span", { className: "as-of-price" }, "A partir de "),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "symbol discounted-price" }, "R$"),
                    react_1.default.createElement("span", { className: "price-value discounted-price" }, suite.priceValueFormatted),
                    react_1.default.createElement("span", { className: "period" }, "/di\u00E1ria")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "as-of-price" }, "A partir de "),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: "symbol" }, "R$"),
                    react_1.default.createElement("span", { className: "price-value" }, suite.priceValueFormatted),
                    react_1.default.createElement("span", { className: "period" }, "/di\u00E1ria")))))),
        react_1.default.createElement(antd_1.Row, { justify: "end" }, (rangePickerInitialValues === null || rangePickerInitialValues === void 0 ? void 0 : rangePickerInitialValues.before) && Number(suite.quantity) <= 3 && (react_1.default.createElement("div", { className: "quantityFormat" },
            react_1.default.createElement(Text_1.default, null,
                "Apenas",
                react_1.default.createElement(Text_1.default, { color: "--main-color", style: { margin: 2 } },
                    suite.quantity,
                    "\u00A0",
                    Number(suite.quantity) > 1 ? 'suítes' : 'suíte'),
                Number(suite.quantity) > 1 ? 'disponíveis' : 'disponível')))),
        react_1.default.createElement(antd_1.Modal, { wrapClassName: "Suite-wrap-modal", title: "", width: 1000, visible: isModalSuiteVisible, onOk: () => hiddenModalSuite(), onCancel: () => hiddenModalSuite(), footer: [] },
            react_1.default.createElement("div", { className: "suite-modal-body" },
                react_1.default.createElement(antd_1.Form, { form: form, onFinish: handleSelectData, initialValues: initialData, labelAlign: "left", layout: "vertical", noValidate: true, className: "form-container" },
                    react_1.default.createElement("div", { className: "top-container" },
                        react_1.default.createElement("div", { className: "description-container" },
                            react_1.default.createElement("div", { className: "suite-name" },
                                react_1.default.createElement("span", null, suite.suiteTitle)),
                            react_1.default.createElement("div", { className: "description" }, suite.description),
                            react_1.default.createElement("div", { className: "sep-div" }),
                            react_1.default.createElement("div", { className: "building-name" },
                                react_1.default.createElement("span", null, suite.buildingName)),
                            react_1.default.createElement("div", { className: "address" }, suite.address),
                            react_1.default.createElement("div", { className: "modal-price" }, (showContinueButton && confirmValues.discountPercent && confirmValues.discountPercent > 0) ||
                                (!showContinueButton && suite.discountPercent && suite.discountPercent > 0) ? (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", { className: "discount-percentage" }, `${showContinueButton ? confirmValues.discountPercent : suite.discountPercent}% off`),
                                react_1.default.createElement("span", { className: "original-price" }, `R$ ${showContinueButton ? confirmValues.priceGrossFormatted : suite.priceGrossFormatted}`),
                                react_1.default.createElement("div", { className: "price" },
                                    react_1.default.createElement("span", { className: "symbol discounted-price" }, "R$"),
                                    react_1.default.createElement("span", { className: "price-value discounted-price" }, showContinueButton ? confirmValues.priceValueFormatted : suite.priceValueFormatted),
                                    react_1.default.createElement("span", { className: "period" }, "/di\u00E1ria")))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("div", { className: "price" },
                                    react_1.default.createElement("span", { className: "symbol" }, "R$"),
                                    react_1.default.createElement("span", { className: "price-value" }, showContinueButton ? confirmValues.priceValueFormatted : suite.priceValueFormatted),
                                    react_1.default.createElement("span", { className: "period" }, "/di\u00E1ria"))))),
                            react_1.default.createElement("div", { className: "price-warning" },
                                react_1.default.createElement("span", { className: "warning-message" }, "*Os valores s\u00E3o flutuantes e podem variar diariamente."))),
                        react_1.default.createElement("div", { className: "slider-container" },
                            react_1.default.createElement("div", { className: "slider" },
                                react_1.default.createElement(galleryImagesComponent_1.default, { imagesList: suite.gallery, showGalleryScroll: false })),
                            react_1.default.createElement("div", { className: "fields-container" },
                                react_1.default.createElement(antd_1.Spin, { spinning: loading },
                                    react_1.default.createElement(RangePickerComponent_1.default, { form: form, name: rangePickerBookingName, unavailableDates: unavailableDates, initialDate: initialDate.toLocaleDateString('pt-BR'), finalDate: finalDate.toLocaleDateString('pt-BR'), initialValues: rangePickerInitialValues, disabled: disableDate, onChange: () => __awaiter(void 0, void 0, void 0, function* () {
                                            const initialDateString = form.getFieldValue(`initialDate-${rangePickerBookingName}`);
                                            const finalDateString = form.getFieldValue(`finalDate-${rangePickerBookingName}`);
                                            const guests = form.getFieldValue(`${guestsBookingName}Guests`);
                                            yield loadModalRoomByDate(initialDateString, finalDateString, guests);
                                            setShowContinueButton(initialDateString && finalDateString);
                                            // Ao mudar a data, apaga a mensagem de validação caso exista
                                            setShowRangeError(false);
                                        }) }),
                                    showRangeError && (react_1.default.createElement("div", { className: "ant-form-item-explain ant-form-item-explain-error", style: { textAlign: 'center' } }, "Selecione as datas"))),
                                react_1.default.createElement("div", { className: "guest-component noselect" },
                                    react_1.default.createElement(UserIcon_1.default, null),
                                    react_1.default.createElement(SelectGuestComponent_1.default, { form: form, baseName: guestsBookingName, initialQtyGuests: guestsInitialValue, maxGuests: suite.maxPeople, onChange: () => __awaiter(void 0, void 0, void 0, function* () {
                                            const initialDateString = form.getFieldValue(`initialDate-${rangePickerBookingName}`);
                                            const finalDateString = form.getFieldValue(`finalDate-${rangePickerBookingName}`);
                                            const guests = form.getFieldValue(`${guestsBookingName}Guests`);
                                            yield loadModalRoomByDate(initialDateString, finalDateString, guests);
                                        }) }))))),
                    react_1.default.createElement("div", { className: "bottom-container" },
                        react_1.default.createElement("div", { className: "amenities-container" },
                            react_1.default.createElement("div", { className: "title amenities-container-mobile", onClick: () => {
                                    setAmenitiesMobileVisible(!amenitiesMobileVisible);
                                } },
                                react_1.default.createElement("span", { className: "noselect" }, "Comodidades "),
                                react_1.default.createElement("span", { className: "open-amenities" }, amenitiesMobileVisible ? react_1.default.createElement(icons_1.CaretDownOutlined, null) : react_1.default.createElement(icons_1.CaretUpOutlined, null))),
                            react_1.default.createElement("div", { className: `items-container ${amenitiesMobileVisible ? null : 'hide-amenities-mobile'}` },
                                react_1.default.createElement(Amenities_1.default, { name: suite.buildingName, roomId: suite.roomId, withHeader: false }))),
                        react_1.default.createElement("div", { className: "select-data-container" }, disableDate || showContinueButton ? (react_1.default.createElement(antd_1.Button, { className: "continue", htmlType: "submit", disabled: disableContinueButton }, "Continuar")) : (react_1.default.createElement(antd_1.Button, { htmlType: "submit" }, "Selecione a data"))))))),
        react_1.default.createElement(antd_1.Modal, { title: `Comodidades - ${suite.suiteTitle}`, destroyOnClose: true, visible: isModalCheckAmenities, onCancel: () => setIsModalCheckAmenities(false), footer: [] },
            react_1.default.createElement(Amenities_1.default, { name: suite.buildingName, roomId: suite.roomId, withHeader: false })),
        react_1.default.createElement(antd_1.Modal, { wrapClassName: "Confirm-wrap-modal", title: "", width: "100%", style: { top: 200 }, visible: isModalConfirmVisible, onOk: () => setIsModalConfirmVisible(false), onCancel: () => {
                setIsModalConfirmVisible(false);
                setIsModalSuiteVisible(true);
            } },
            react_1.default.createElement("div", { className: "confirm-modal-body" },
                react_1.default.createElement("div", { className: "confirm-data-container" },
                    react_1.default.createElement("div", { className: "section-confirm-logo-container" },
                        react_1.default.createElement("img", { src: logo_webp_1.default, alt: "" })),
                    react_1.default.createElement("div", { className: "div-bar first-div-bar" }),
                    react_1.default.createElement("div", { className: "section-confirm-data-container" },
                        react_1.default.createElement("div", { className: "days-container" },
                            react_1.default.createElement("div", { className: "title" }, "SUA RESERVA"),
                            react_1.default.createElement("div", { className: "content" },
                                react_1.default.createElement("div", { className: "" },
                                    react_1.default.createElement("img", { src: calendar_icon_white_svg_1.default, alt: "", style: { width: 35 } })),
                                react_1.default.createElement("div", { className: "selected-day-container" },
                                    react_1.default.createElement("div", { className: "day" }, confirmValues.initialDay),
                                    react_1.default.createElement("div", { className: "month" },
                                        react_1.default.createElement("div", { className: "month-item" }, confirmValues.initialDayWeek),
                                        react_1.default.createElement("div", { className: "month-item" }, confirmValues.initialmonth))),
                                react_1.default.createElement("div", { className: "icon" },
                                    react_1.default.createElement(icons_1.CaretRightOutlined, null)),
                                react_1.default.createElement("div", { className: "selected-day-container" },
                                    react_1.default.createElement("div", { className: "day" }, confirmValues.finalDay),
                                    react_1.default.createElement("div", { className: "month" },
                                        react_1.default.createElement("div", { className: "month-item" }, confirmValues.finalDayWeek),
                                        react_1.default.createElement("div", { className: "month-item" }, confirmValues.finalmonth)))),
                            react_1.default.createElement("span", { className: "check-amenities", onClick: () => setIsModalCheckAmenities(true) }, "Conferir comodidades")),
                        react_1.default.createElement("div", { className: "div-bar" }),
                        react_1.default.createElement("div", { className: "selected-data-container" },
                            react_1.default.createElement("div", { className: "" },
                                confirmValues.suiteQtyString,
                                "\u00A0",
                                react_1.default.createElement("span", null, confirmValues.suiteQtyString === '01' ? 'SUÍTE' : 'SUÍTES')),
                            react_1.default.createElement("div", { className: "" },
                                confirmValues.dailyQtyString,
                                "\u00A0",
                                react_1.default.createElement("span", null, confirmValues.dailyQtyString === '01' ? 'DIÁRIA' : 'DIÁRIAS')),
                            react_1.default.createElement("div", { className: "" },
                                confirmValues.guestsQtyString,
                                "\u00A0",
                                react_1.default.createElement("span", null, confirmValues.guestsQtyString === '01' ? 'HÓSPEDE' : 'HÓSPEDES'))),
                        react_1.default.createElement("div", { className: "div-bar" }),
                        react_1.default.createElement("div", { className: "price-container" },
                            react_1.default.createElement("div", { className: "description" }, "SU\u00CDTE"),
                            react_1.default.createElement("div", { className: "price" },
                                "R$",
                                ` ${confirmValues.suitePrice}`),
                            react_1.default.createElement("div", { className: "description" }, "TAXA LIMPEZA"),
                            react_1.default.createElement("div", { className: "price" },
                                "R$",
                                ` ${confirmValues.cleaningFeeFormated}`)),
                        react_1.default.createElement("div", { className: "div-bar" }),
                        react_1.default.createElement("div", { className: "total-container" },
                            react_1.default.createElement("div", { className: "total-value" },
                                react_1.default.createElement("div", { className: "total-left-container" },
                                    react_1.default.createElement("div", { className: "total-text" }, "TOTAL"),
                                    react_1.default.createElement("div", { className: "total-currency" }, "R$")),
                                react_1.default.createElement("div", { className: "total-number" }, confirmValues.totalNumber),
                                react_1.default.createElement("div", { className: "total-decimal" },
                                    react_1.default.createElement("span", null, ","),
                                    confirmValues.totalDecimal)),
                            react_1.default.createElement(antd_1.Button, { onClick: handleSubmit, loading: loading }, "Confirmar reserva"))))))));
};
exports.default = BookComponent;
